export default "__VITE_ASSET__2ea92488__"